import { ActionTree } from 'vuex'
import { LaunchDarklyService } from '@/services/ld.service'
import { identifySegmentUser } from 'vue-common/src/services/analytics/segment.service'

function isE2E(email: string) {
  return email.includes('e2e')
}

export const actions: ActionTree<unknown, unknown> = {
  async IDENTIFY_USER({ commit }, user) {
    // Segment Identify
    identifySegmentUser(user)

    // Launch Darkly Identify
    if (user?.email && user?.sub) {
      const userFlags = await LaunchDarklyService.instance.identify(user.email, user.sub)
      commit('SET_FEATURE_FLAGS', userFlags)
    }
  }
}
